import React, { createContext, useState, useContext, useEffect } from 'react';

const DivisionContext = createContext();

export const useDivision = () => {
  const context = useContext(DivisionContext);
  if (!context) {
    throw new Error('useDivision must be used within DivisionProvider');
  }
  return context;
};

export const DivisionProvider = ({ children }) => {
  const [division, setDivision] = useState(() => {
    // Get from localStorage or default to 'texas'
    return localStorage.getItem('millmetrix_division') || 'texas';
  });

  useEffect(() => {
    // Save to localStorage whenever it changes
    localStorage.setItem('millmetrix_division', division);
  }, [division]);

  const switchDivision = (newDivision) => {
    setDivision(newDivision);
  };

  const getDivisionLabel = () => {
    return division === 'texas' ? 'Texas' : 'Louisiana';
  };

  const getCountyLabel = () => {
    return division === 'texas' ? 'County' : 'Parish';
  };

  return (
    <DivisionContext.Provider
      value={{
        division,
        switchDivision,
        getDivisionLabel,
        getCountyLabel
      }}
    >
      {children}
    </DivisionContext.Provider>
  );
};

export default DivisionContext;
